import { User } from 'src/types/models';
import { isTrinityUser } from 'src/utils/user';

// Phase 2 (Downstream Impact panel, acknowledgment). Nothing renders while false.
export const PHASE2_DOWNSTREAM_IMPACT = false as const;
// POST …/merge/submit shipped with CLD-2971 (CONC-6); enabled 2026-10-13 (owner
// decision). A kill switch: set false and submit() fails closed, with no
// network call.
export const SUBMIT_ROUTE_ENABLED = true as const;
// merge/rows PageSize (server max 500).
export const PAGE_SIZE = 100 as const;
// Custom value: trimmed, non-empty, one line, at most this many characters.
export const CUSTOM_VALUE_MAX_LEN = 50 as const;
// Mock-only review harness for the resolve screen (no API calls, fixtures
// only). Fails closed: anything other than the exact string 'true' leaves it
// off, so an unset or misspelled variable cannot enable it. The route is ALSO
// gated on isTrinityUser() - see mockResolveRouteEnabled - so this flag alone
// does not expose it to a client user.
export const MOCK_RESOLVE_ENABLED =
  process.env.REACT_APP_ENABLE_MOCK_RESOLVE === 'true';

export const MOCK_RESOLVE_PATH = '/scenario-manager/resolve-conflicts-mock';

/**
 * Whether the harness route should be mounted at all. Both conditions must
 * hold, and either one alone is enough to keep the route off:
 *
 *  - MOCK_RESOLVE_ENABLED, a build-time flag that is false unless
 *    REACT_APP_ENABLE_MOCK_RESOLVE is exactly 'true', so the route is absent
 *    from any build that does not deliberately ask for it; and
 *  - the same Trinity-only check that guards the admin routes, so a client
 *    user cannot reach it even in a build where the flag is on.
 *
 * Fails closed on an absent user. Lives here rather than next to the harness
 * so Routes.tsx can decide without statically importing the harness, which
 * would pull it and its fixtures into the main bundle.
 */
export const mockResolveRouteEnabled = (user: User | undefined): boolean =>
  MOCK_RESOLVE_ENABLED && user !== undefined && isTrinityUser(user);
